import script from "./TableSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./TableSearch.vue?vue&type=script&setup=true&lang=js"

import "./TableSearch.vue?vue&type=style&index=0&id=519f51e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-519f51e2"]])

export default __exports__